export default __webpack_public_path__ + "static/aventure-specs-26a1a49195ef3c33200892892d7c673a.jpg";